import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Cashew from "./pages/Cashew";
import Almonds from "./pages/Almonds";
import Raisins from "./pages/Raisins";
import Pistachios from "./pages/Pistachios";
import Walnuts from "./pages/Walnuts";
import Cardamons from "./pages/Cardamons";
import Cloves from "./pages/Cloves";
import BlackPepper from "./pages/BlackPepper";
import GaramMasala from "./pages/GaramMasala";
import BasmatiRice from "./pages/BasamatiRice";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/cashew" element={<Cashew />} />
        <Route path="/product/almonds" element={<Almonds />} />
        <Route path="/product/cardamons" element={<Cardamons />} />
        <Route path="/product/cloves" element={<Cloves />} />
        <Route path="/product/black-pepper" element={<BlackPepper />} />
        <Route path="/product/garam-masala" element={<GaramMasala />} />
        <Route path="/product/basmati-rice" element={<BasmatiRice />} />
        <Route path="/product/raisins" element={<Raisins />} />
        <Route path="/product/pistachios" element={<Pistachios />} />
        <Route path="/product/walnuts" element={<Walnuts />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
